import React from 'react';
// import PropTypes from 'prop-types';
import { useQuery } from 'relay-hooks';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router-dom';

import Container from 'react-bootstrap/Container';

import DogChildren from '../../dogs/DogChildren';

// import DebugDump from '../components/DebugDump';

export default function Breedings() {
  const { id } = useParams();

  const { props: queryResult, error: queryError } = useQuery(
    graphql`
      query Breedings_Query($id: Id!) {
        dog(id: $id) {
          ...DogChildren_dog
        }
      }
    `,
    {
      id,
    },
  );

  const { dog } = queryResult ?? {};

  return (
    <Container>
      {queryError ? (
        <>
          <div>Error: {queryError.message}</div>
          <div>Source: {JSON.stringify(queryError.source)}</div>
        </>
      ) : !queryResult ? (
        <div>Loading...</div>
      ) : (
        <>
          <DogChildren dog={dog} />
        </>
      )}
    </Container>
  );
}
